import React, { useMemo } from 'react';
import './index.scss';
import { getCategoryImage } from '../../utils/services';
import BURGER_IMAGE from './burger.jpeg';

const PreMealImage = ({
  imageUrls = null,
  alt = 'Burger',
  category = 'hpiv',
  className
}) => {
  const imageUrlMemo = useMemo(() => {
    return getCategoryImage(imageUrls, category);
  }, [imageUrls, category]);

  if (!imageUrls) {
    return (
      <img
        src={BURGER_IMAGE}
        alt={alt}
        className={`meal-card__image ${className || ''}`}
      />
    );
  }

  return (
    <picture>
      <source
        srcSet={`${imageUrlMemo['1x']}, ${imageUrlMemo['2x']} 2x, ${imageUrlMemo['3x']} 3x`}
        type="image/jpeg/png"
      />
      <img
        src={`${imageUrlMemo['2x']}`}
        alt={alt}
        className={`meal-card__image ${className || ''}`}
      />
    </picture>
  );
};

export default PreMealImage;
